/**
 * O número vermelho no menu (05/10): quantos vencem as 24 h em menos de quatro horas, em
 * cada uma das duas filas — sem precisar estar na tela para saber.
 *
 * É o cartão *Vencem 24 h em < 4 h* da Operação e o *Prazo crítico 24 h* da SENATRAN,
 * pedidos à mesma régua (`GET /tollvision/regua`) com o mesmo universo de cada tela. Não há
 * uma terceira contagem: o número do menu é o do cartão, por construção (`AC04`).
 *
 * Relido a cada minuto e a cada troca de tela — quem aprova na Operação e vai para a
 * SENATRAN vê o menu acompanhar. Só pergunta com o TollVision licenciado; qualquer falha
 * apaga o número em vez de inventar um.
 */
import { useEffect, useState } from "react";

import { api } from "../api/cliente";
import type { Regua } from "../api/tipos";
import { repetirComAbaVisivel } from "./repetirComAbaVisivel";

export const RELEITURA_DO_MENU_MS = 60_000;

/** A área do menu e o universo da fila dela. */
export const UNIVERSO_DA_AREA: Record<string, string> = {
  "/operacao": "na_operacao",
  "/senatran": "senatran",
};

export const CARTAO_DO_ALERTA = "prazo_24h_critico";

export function useAlertasDoMenu(
  ligado: boolean,
  gatilho: string,
): Record<string, number> {
  const [alertas, definirAlertas] = useState<Record<string, number>>({});
  useEffect(() => {
    if (!ligado) return;
    let vivo = true;
    const ler = async () => {
      const respostas = await Promise.allSettled(
        Object.entries(UNIVERSO_DA_AREA).map(async ([area, universo]) => {
          const p = new URLSearchParams({
            recorte: universo,
            cartao: CARTAO_DO_ALERTA,
          });
          const regua = await api<Regua>(`/tollvision/regua?${p.toString()}`);
          return [area, regua[CARTAO_DO_ALERTA]] as const;
        }),
      );
      if (!vivo) return;
      const novos: Record<string, number> = {};
      for (const r of respostas)
        if (r.status === "fulfilled" && typeof r.value[1] === "number")
          novos[r.value[0]] = r.value[1];
      definirAlertas(novos);
    };
    void ler();
    const parar = repetirComAbaVisivel(() => void ler(), RELEITURA_DO_MENU_MS);
    return () => {
      vivo = false;
      parar();
    };
  }, [ligado, gatilho]);
  // Desligado (o módulo deixou de constar), o que foi lido antes não vale mais.
  return ligado ? alertas : SEM_ALERTAS;
}

const SEM_ALERTAS: Record<string, number> = {};
